import { useNavigate } from "react-router-dom";
import { ArrowRight, CheckCircle2 } from "lucide-react";
import { useLanguage } from "@/i18n/LanguageProvider";
export function checkInNextStep(energy: number | null, intentions: readonly string[] | null) {
  if (energy !== null && energy <= 2) return { key: "gentle", to: "/agenda" };
  const intent = intentions?.[0];
  if (intent === "work") return { key: "focus", to: "/focus" };
  if (intent === "learning") return { key: "learn", to: "/brain-training" };
  if (intent === "rest") return { key: "rest", to: "/sleep" };
  if (intent === "create") return { key: "create", to: "/notes" };
  if (intent === "health") return { key: "health", to: "/fitness" };
  return { key: "day", to: "/agenda" };
}
export default function CheckInNextStep({ energy, intentions, intentionText }: {
  energy: number | null; intentions: readonly string[] | null; intentionText?: string | null;
}) {
  const { t } = useLanguage();
  const navigate = useNavigate();
  const action = checkInNextStep(energy, intentions);
  return <section className="w-full rounded-2xl border border-primary/25 bg-primary/5 p-5 text-left" aria-labelledby="checkin-next-title">
    <p className="flex items-center gap-2 text-sm text-primary"><CheckCircle2 size={17} aria-hidden="true" />{t("checkin.next.saved")}</p>
    <h2 id="checkin-next-title" className="mt-3 text-lg font-semibold">{t("checkin.next.title")}</h2>
    <p className="mt-2 text-sm leading-relaxed text-muted-foreground">{t(`checkin.next.${action.key}Hint`)}</p>
    {intentionText?.trim() && <blockquote className="mt-3 border-l-2 border-primary/40 pl-3 text-sm leading-relaxed break-words">{intentionText}</blockquote>}
    <button type="button" onClick={() => navigate(action.to)} className="mt-4 min-h-12 flex items-center justify-between gap-3 rounded-xl bg-primary px-4 py-3 text-sm font-semibold text-primary-foreground focus-visible:ring-2 focus-visible:ring-primary focus-visible:ring-offset-2 focus-visible:ring-offset-background">
      {t(`checkin.next.${action.key}`)}<ArrowRight size={18} aria-hidden="true" />
    </button>
    <p className="mt-3 text-xs leading-relaxed text-muted-foreground">{t("checkin.next.hint")}</p>
  </section>;
}
